import Box from "@mui/material/Box";
import { useTheme } from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { DeviceStatusOverviewData } from "@/models/DeviceStatusOverviewData";

export function DeviceActivityCell(props: GridRenderCellParams<DeviceStatusOverviewData>) {
  const communicating = props.row.statusData?.isDeviceCommunicating;
  const isActive = new Date(props.row.device?.activeTo) >= new Date();
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <Box sx={{ display: "flex", alignItems: "center", height: "100%" }}>
      <Tooltip
        title={communicating ? t("deviceStatus.communicating") : t("deviceStatus.notCommunicating")}
      >
        <Box
          sx={{
            marginRight: 1,
            height: "10px",
            width: "10px",
            borderRadius: "5px",
            flexShrink: 0,
            backgroundColor: communicating ? theme.palette.success.main : theme.palette.error.main,
          }}
        />
      </Tooltip>
      <Tooltip title={isActive ? t("deviceStatus.active") : t("deviceStatus.archived")}>
        <span
          style={{
            whiteSpace: "normal",
            lineHeight: "normal",
            color: isActive ? "inherit" : "gray",
            textAlign: "left",
          }}
        >
          {props.value ?? "---"}
        </span>
      </Tooltip>
    </Box>
  );
}
